import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { FaArrowRight, FaChartLine, FaUnlockAlt, FaLaptopCode } from "react-icons/fa";
import "./../styles/GoldPlus.css";
import heroImg from "../assets/gold-plus.jpg";

export default function GoldPlus() {

  // Scroll to top on load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  };

  return (
    <div className="gpPage">

      {/* 1. HERO SECTION */}
      <section className="gpHero">
        <motion.div
          className="gpHeroContent"
          initial="hidden"
          animate="visible"
          variants={staggerContainer}
        >
          <motion.div variants={fadeUp} className="gpBadge">Premium Service</motion.div>
          <motion.h1 variants={fadeUp}>Seamless Online Gold Assets</motion.h1>
          <motion.p variants={fadeUp}>
            Welcome to the future of asset management. Secure gold dynamically at the
            current market rate and redeem your assets anytime you need. RAMB's Gold Plus
            platform is fully online, offering you 100% control over your portfolio from
            anywhere in the world.
          </motion.p>

          <motion.div variants={fadeUp} className="gpActions">
            <button
              className="gpBtnPrimary"
              onClick={() => window.location.href = "https://newramb.smartomegalk.com/gold/register"}
            >
              Register to Gold Plus <FaArrowRight />
            </button>
            <button
              className="gpBtnOutline"
              onClick={() => {
                // Scroll to features if requested, or just act as a dummy
                window.scrollBy({ top: window.innerHeight * 0.8, behavior: 'smooth' })
              }}
            >
              Discover Benefits
            </button>
          </motion.div>
        </motion.div>

        <motion.div
          className="gpHeroImg"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <img src={heroImg} alt="Gold Plus Assests" />
          <div className="gpImgOverlay" />
        </motion.div>
      </section>

      {/* 2. FEATURES GRID */}
      <motion.section
        className="gpFeatures"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={staggerContainer}
      >
        <motion.div className="gpFeatureCard" variants={fadeUp}>
          <div className="gpIconWrap"><FaChartLine /></div>
          <h3>Real-Time Rates</h3>
          <p>Act confidently with live market data. Our platform ensures you always act on the exact current value of gold.</p>
        </motion.div>

        <motion.div className="gpFeatureCard" variants={fadeUp}>
          <div className="gpIconWrap"><FaUnlockAlt /></div>
          <h3>Flexible Redemption</h3>
          <p>Liquidity is key. Access your value easily—redeem your assets at any time with transparent valuation.</p>
        </motion.div>

        <motion.div className="gpFeatureCard" variants={fadeUp}>
          <div className="gpIconWrap"><FaLaptopCode /></div>
          <h3>100% Online</h3>
          <p>Ditch the paperwork. Your entire journey is streamlined electronically, available 24/7 on our secure portal.</p>
        </motion.div>
      </motion.section>

      {/* 3. DISCLAIMER */}
      <motion.div
        className="gpDisclaimer"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        <p>
          <em>*Terms and conditions applied. Assets are subject to market risks.
            For comprehensive details on policies, rates, and redemption terms, please visit the
            <a href="https://newramb.smartomegalk.com/gold/login"> online portal </a>
            or contact your local RAMB branch directly.*</em>
        </p>
      </motion.div>

    </div>
  );
}